import { jsonPost } from 'fetch_utils';

import type { ApiResponse2 as ApiResponse } from '@shopee/create-api-request';
import type {
  MartRcmdItemsByCategoryResponse,
  MartSearchItemsResponse,
} from './types';
import { FetchUtils } from '@shopee/platform';
import { formatToApiResponse } from '@shopee/search-common-util';

const API_ENDPOINT = '/api/v4/search/search_mart_items';
const URL_MART_MPI_RCMD_ITEM_BY_CATEGORY =
  '/api/v4/mpi/rcmd/get_recommended_items_by_category';
const appKey = __PLATFORM__ === 'pc' ? 'Search.PC' : 'Search.RW';

const antiFraudConfig = {
  antiCrawler: {
    appKey,
  },
  deviceFingerPrint: {},
  apiProtection: {},
};

export async function fetchMartSearchItems(query: string) {
  const res = await FetchUtils.get<MartSearchItemsResponse>(
    `${API_ENDPOINT}${query}`,
    { antiFraudConfig }
  );
  return formatToApiResponse(res);
}

// https://confluence.shopee.io/pages/viewpage.action?spaceKey=SDLT&title=Shopee+Mart+v2.5+-+Category+Page+Recommended+Categories+Strategy+Improvement
export function fetchMartRcmdItemsByCategory({
  offset,
  limit,
  mpiCategoryIds,
}: {
  offset: number;
  limit: number;
  mpiCategoryIds: number[];
}) {
  return jsonPost(URL_MART_MPI_RCMD_ITEM_BY_CATEGORY, {
    offset,
    limit,
    category_id: mpiCategoryIds,
  }) as Promise<ApiResponse<MartRcmdItemsByCategoryResponse>>;
}
